export const SETUP_ADYEN_INTENT = 'adyen/SETUP_ADYEN_INTENT';
export const UPDATE_ADYEN_MOP_RESULT = 'adyen/UPDATE_ADYEN_MOP_RESULT';
